<template>
  <HiddenInput input-id="id" />
  <VPInput
    input-id="description"
    label="Description"
  />
  <VPInput
    input-id="loaderUrl"
    label="Loader url"
  />
  <VPTextarea
    input-id="configuration"
    label="Configuration"
    class="h-64"
  />
  <div
    v-if="configStr.trim()"
    class="my-8"
  >
    <template v-if="jsonErrors">
      Configuration is invalid: {{ jsonErrors }}
    </template>
    <template v-else>
      Configuration is valid
    </template>
  </div>

  <VPTextarea
    input-id="style"
    label="Styles"
    class="h-64"
  />
</template>

<script setup lang="ts">
import { HiddenInput, useFormsStoreComposable } from 'vuniform';
import VPInput from '@/components/form/VPInput.vue';
import VPTextarea from '@/components/form/VPTextarea.vue';
import { computed, inject } from 'vue';

const formId = inject('formId', '');

const { fieldGetValue } = useFormsStoreComposable(formId);

const configStr = computed(() => <string>fieldGetValue('configuration') || '');
const jsonErrors = computed(() => {
  if (!configStr.value.trim()) {
    return null;
  }

  try {
    JSON.parse(configStr.value);
    return null;
  } catch (e: any) {
    return e.message;
  }
});
</script>
